<template>
    <div>
        <a v-bind:href="href">
            <BButton
                :variant="variant" class="waves-effect waves-themed" size="sm">
                {{ tender_info }}
            </BButton>
        </a>
    
    </div>
</template>

<script>

import {mapGetters} from 'vuex';
import {
    BButton,
} from 'bootstrap-vue-next';

export default {
    name: "tenderInfo",
    
    components : {
        BButton
    },
    
    props : {
        row : {
            type : Object,
            required : true,
        }
    },

    methods: {
    
    },
    
    computed: {
        ...mapGetters({
            'user_id': "user/getUserId",
            'user': "user/getUser",
        }),
        
        tender_info() {
            let text = 'Перегляд';
            try {
                if(this.user_auth && this.date_ok && !this.serv_id) {
                    text = 'Подати Заявку'
                }
            }
            catch (e) {
            
            }
            
            return text;
        },
        
        variant() {
            let variant = 'outline-primary'
            
            if(this.user_auth && this.date_ok) {
                variant = 'primary'
            }
            return variant;
        },
        
        user_auth() {
            return parseInt(this.user_id) > 0;
        },
        
        serv_id () {
            return parseInt(this.user?.serv_id) > 0;
        },
        
        date_ok () {
            let today = new Date();
            let now = Date.now();
            let date_to = Date.parse(this.row.date_to.replace(' ', 'T'))
            
            return date_to > now;
        },
        
        href () {
            return '/tenderapp/' + this.row.id;
        }
    }
}
</script>

<style scoped>

</style>
